// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__iZIsl","logo":"Home_logo__oiCAS"};